import { useStaticQuery, graphql } from "gatsby"

const useOffMarketQuery = () => {
  const { allWpProperty } = useStaticQuery(graphql`
    query OffMarketQuery {
      allWpProperty(
        filter: {
          propertyListing: {
            status: {in: ["Available", "Conditional"]},
            hiddenListing: {eq: false},
            offMarketListing: {eq: true}
          },
        }
      )
      {
        nodes {
          ...PropertyCard
        }
      }
    }
  `)
  return allWpProperty.nodes || []
}

export default useOffMarketQuery